import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { TenantState } from '@core/models/tenant.state';
import { MockDataService } from '@core/services/mock-data.service';

import { mockResponse } from '../mock-response';
import { TenantRepository } from './tenant.repository';
import { seedTenants } from './tenant.seed';

const COLLECTION = 'tenants';

@Injectable()
export class TenantMockRepository implements TenantRepository {
  private readonly tenants = inject(MockDataService).collection<TenantState>(COLLECTION, seedTenants);

  getBySlug(slug: string): Observable<TenantState | null> {
    return mockResponse(this.tenants.list().find(t => t.slug === slug) ?? null);
  }

  getBySubdomain(subdomain: string): Observable<TenantState | null> {
    const wanted = subdomain.trim().toLowerCase();
    return mockResponse(this.tenants.list().find(t => t.subdomain.toLowerCase() === wanted) ?? null);
  }

  listAll(): Observable<TenantState[]> {
    return mockResponse(this.tenants.list());
  }
}
